/**
 * Created by matheusmorett on 22/08/17.
 */
import React, {Component} from 'react';
import {inject, observer} from 'mobx-react';
import Modal from 'react-modal';
import ReactPlaceholder from 'react-placeholder';
import {ToastContainer, toast} from 'react-toastify';
import { Grid } from 'components/Grid';
import Utils from 'utils/Utils';
import { BY_CATEGORY } from './../../utils/Consts';
import './MoreAdventure.scss';

import Register from './../Register';
import Login from './../Login';

import AdventureCard from 'components/AdventureCard';
import { JSONLD, Generic } from 'react-structured-data';

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        display: 'flex',
        background: 'none',
        boxShadow: 'none',
        zIndex: '999',
        backgroundColor: "rgba(255, 255, 255, 0.9);"
    }
};

export const openLogin = 1;

@inject("AdventuresStore", "AuthStore", "SearchStore", "ApplicationStore")
@observer
class MoreAdventure extends Component {

    static defaultProps = {
        getByCategory: () => {
        },
        getAllAdventures: () => {
        },
        getByType: () => {
        },
        seeMore: ''
    };

    constructor(props) {
        super(props);

        this.state = {
            page: 1,
            noAdventures: false,
            modalIsOpen: false,
            formOpen: null,
            lat: "",
            lng: "",
            recieveLatLng: false,
            ready: false
        };

        this.openModal = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
    }

    componentWillReceiveProps(props) {
        this.setState({...props});
    }

    openModal(formOpen) {
        this.setState({
            formOpen: formOpen,
            modalIsOpen: true
        });
    }

    closeModal() {
        this.setState({modalIsOpen: false});
    }

    handleFavorite(pkAdventure) {
        if (this.props.AuthStore.isLogged) {
            const params = {
                fk_adventure: pkAdventure
            };

            const adventure = this.props.Adventures.find(a => a.pkAdventure === pkAdventure);
            if (adventure.favorite === true) {
                toast("Aventura removida!");
                this.props.AdventuresStore.unsetFavorite(params);
            } else {
                toast("Aventura adicionada aos favoritos!");
                this.props.AdventuresStore.setFavorite(params);
            }

        } else {
            this.openModal(1);
        }
    }

    render() {
        const  { ApplicationStore, match } = this.props;

        return (
            <section id="more-adventure"
                className={"more-adventure" + (this.props.typeSearch === BY_CATEGORY || this.props.noTop ? " top-0" : "")}>
                <div className="wrapper">
                    <Modal
                        isOpen={this.state.modalIsOpen}
                        onRequestClose={this.closeModal}
                        style={customStyles}
                        contentLabel="Cadastre-se"
                    >
                        <div className="box-modal">
                            <div className="Grid Grid--gutter Grid-column">
                                <div className="Grid-cell">
                                    <div className="close-modal">
                                        <p className="float-right" onClick={this.closeModal}>
                                            Fechar X
                                        </p>
                                    </div>
                                </div>
                                <div className="Grid-cell">
                                    {(this.state.formOpen === openLogin) ?
                                        <Login closeModal={this.closeModal.bind(this)}/> :
                                        <Register closeModal={this.closeModal.bind(this)}/>}
                                </div>
                            </div>
                        </div>
                    </Modal>
                    <ToastContainer
                        position="top-right"
                        type="default"
                        autoClose={2000}
                        hideProgressBar={false}
                        newestOnTop={false}
                        closeOnClick
                        pauseOnHover
                    />
                    <div className="more-adventure-wrapper">
                        {
                        !this.props.noTitle &&
                        <div className="Grid-column">
                            <div className="Grid-cell">
                                <ReactPlaceholder type='text' rows={1} showLoadingAnimation  ready={!!(this.props.title)}>
                                    <h2 className="title">
                                        {Utils.highlightText(this.props.title)}
                                    </h2>
                                </ReactPlaceholder>                              
                            </div>
                            {this.props.seeMore && (<div className="seeMore">{this.props.seeMore}</div>)}
                        </div>
                        }
                        <div className="Grid-cell">
                            <ReactPlaceholder type='rect' showLoadingAnimation style={{
                                width: 262,
                                height: 187,
                                margin: 15,
                                marginLeft: "0"
                            }} ready={!!(this.props.Adventures.length > 0 && !this.props.adventuresLoading)}>
                                <Grid>
                                    {this.props.Adventures.map(
                                        a => <AdventureCard adventure={a} onFavorite={this.handleFavorite.bind(this)} isLogged={this.props.AuthStore.isLogged} minimal={ApplicationStore.minimalTemplate} key={a.pkAdventure} />
                                    )}
                                </Grid>
                            </ReactPlaceholder>
                        </div>
                    </div>
                    {
                        this.props.Adventures.length > 0 && 
                        <JSONLD>
                            <Generic 
                                type="OfferCatalog"
                                jsonldtype="OfferCatalog"
                                schema={{
                                    name: this.props.noTitle ? "Mais aventuras" : this.props.title.replace(new RegExp(/\*/g),''),
                                    itemListElement: this.props.Adventures.map(adv => ({
                                        "@type": "Offer",
                                        itemOffered: {
                                            "@type": "Product",
                                            name: adv.title,
                                            image: adv.image,
                                            description: adv.description || adv.long_description,
                                            url: `${adv.urn}`,
                                            category: adv.categoryName,
                                            offers: {
                                                "@type": "Offer",
                                                price: adv.price,
                                                priceCurrency: "BRL"
                                            },
                                            brand: {
                                                "@type": "Brand",
                                                name: adv.company
                                            }
                                        },
                                        price: adv.price,
                                        priceCurrency: "BRL"
                                    })),
                                    numberOfItems: this.props.Adventures.length
                                }}
                            />
                        </JSONLD>
                    }
                    {(this.props.loading &&
                        <div className="icon-loadmore">
                            <span className='icon icon-refresh fa-spin'/>
                        </div>
                    )}
                </div>
            </section>
        )
    }

}
export default MoreAdventure;